import { useTheme as useDefaultTheme } from 'styled-components';
export const useTheme = () => useDefaultTheme();
//# sourceMappingURL=useTheme.js.map